<p-toast [position]="'top-right'" [styleClass]="'right-5 max-w-[100vw] !top-18 '">
  <ng-template let-message #headless pTemplate="message" let-closeFn="closeFn">
    <div class="flex items-center gap-3 px-5 py-4 bg-gray-700 border-gray-700 rounded-sm">
      <i
        class="text-xl bx"
        [ngClass]="{
          'bxs-info-circle text-blue-400': message.severity === 'info',
          'bxs-error text-yellow-400': message.severity === 'warn',
          'bxs-x-circle text-red-400': message.severity === 'error',
          'bxs-check-circle text-green-400': message.severity === 'success',
        }"></i>
      <div class="text-body-md-medium text-white">{{ message.detail }}</div>
      <i class="text-xl bx bx-x text-gray-50 cursor-pointer ml-auto" (click)="closeFn($event)" (keydown.enter)="closeFn($event)" (keydown.space)="closeFn($event)"></i>
    </div>
  </ng-template>
</p-toast>
